export interface Villa {
  id: string;
  url: string;
  domain: string;
  title: string | null;
  image: string | null;
  images: string[] | null;
  addedAt: string;
  addedAtFormatted: string;
  status: VillaStatus;
  pinned: boolean;
  phone: string | null;
  comment: string | null;
  price: number | null;
  priceFormatted: string | null;
  district: string | null;
  originalMessageId: string;
}

export type VillaStatus = 'new' | 'contacted' | 'scheduled' | 'visited' | 'shortlisted' | 'archived';

export interface VillasResponse {
  villas: Villa[];
  count: number;
  archivedCount?: number;
  title?: string;
}

export const STATUS_LABELS: Record<VillaStatus, string> = {
  new: 'Новая',
  contacted: 'Написали',
  scheduled: 'Назначен просмотр',
  visited: 'Просмотрена',
  shortlisted: 'Отобрана',
  archived: 'Архив',
};

export const STATUS_COLORS: Record<VillaStatus, string> = {
  new: '#9ca3af', // gray-400
  contacted: '#3b82f6', // blue-500
  scheduled: '#f59e0b', // amber-500
  visited: '#a855f7', // purple-500
  shortlisted: '#22c55e', // green-500
  archived: '#9ca3af', // gray-400
};

// Статусы в порядке отображения (новое — первым)
export const STATUSES_ORDER: VillaStatus[] = ['new', 'contacted', 'scheduled', 'visited', 'shortlisted', 'archived'];

// Районы Бали
export const DISTRICTS = [
  'Canggu',
  'Pererenan',
  'Seseh',
  'Uluwatu',
  'Seminyak',
  'Kuta',
  'Ubud',
  'Sanur',
  'Nusa Dua',
  'Tabanan',
  'North Bali',
] as const;

export type District = typeof DISTRICTS[number];
